export const environment = {
  apiUrl: 'https://consignee-api-dev.starlinks-me.com/api/v1',
  production: false,
  userAgent: 'starlinks-enduser',
  userAgentSecret: '3sk8M85pelCpIL6F7uHy_Gm83kmzSDbKZNbJKqZf06Q'
};
